import { getAxiosInstance } from "../ApiConfig";

async function AllSharedReport() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllSharedReportsByUser/Report`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllReportGroups() {
    try {
        const response = await getAxiosInstance().get(`/Template/getAllReportingGroupByUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ReportQuery(payload) {
    try {
        const response = await getAxiosInstance().post(`/Template/getDataByTemplateQuery`, payload)
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ReportSave(payload) {
    try {
        const response = await getAxiosInstance().post(`/Template/createCustomTemplateQuery`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function ReportDetailsAPi(templateQueryId) {
    try {
        const response = await getAxiosInstance().get(`/Template/getCustomReportDetailByReportingQueryId/${templateQueryId}`);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getAllReportingGroupShareByUser() {
    try {
        const response = await getAxiosInstance().get(`/Template/getAllReportingGroupShareByUser`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateReportingGroupShare(payload) {
    try {
        const response = await getAxiosInstance().put(`/Template/updateReportingGroupShare`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteReportingGroupShare(sharedId) {
    try {
        const data = await getAxiosInstance().delete(`/Template/deleteReportingGroupShare/${sharedId}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function deleteCustomTemplateQuery(sharedId) {
    try {
        const data = await getAxiosInstance().delete(`/Template/deleteCustomTemplateQuery/${sharedId}`);
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function findAllByReportingGroupId(reportingGroupId) {
    try {
        const response = await getAxiosInstance().get(`/Template/findAllByReportingGroupId/${reportingGroupId}`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function createReportingGroupShare(payload) {
    try {
        const response = await getAxiosInstance().post(`/Template/createReportingGroupShare`, payload);
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function fetchAllReportingGroupShare() {
    try {
        const response = await getAxiosInstance().get(`/Template/fetchAllReportingGroupShare`);
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getQualifiedPipelineStageValue(isQualified) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getQualifiedPipelineStageValue/${isQualified}`);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function AllEntityCountsByDuration(state) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/AllEntityCountsByDuration/${state}`);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getDealCountAndValueByPipeline(state) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getDealCountAndValueByPipeline/${state}`);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getTopSalesPersonnel(state) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getTopSalesPersonnel/${state}`);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findAllTopProductByDealOwner() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllTopProductByDealOwner`);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function findAllByDealValuByCurrentAndPast(state) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllByDealValuByCurrentAndPast/${state}`);
        return response.data;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    findAllByDealValuByCurrentAndPast,
    findAllTopProductByDealOwner,
    getTopSalesPersonnel,
    AllEntityCountsByDuration,
    getDealCountAndValueByPipeline,
    AllSharedReport,
    AllReportGroups,
    ReportQuery,
    ReportSave,
    ReportDetailsAPi,
    getAllReportingGroupShareByUser,
    updateReportingGroupShare,
    deleteReportingGroupShare,
    findAllByReportingGroupId,
    createReportingGroupShare,
    fetchAllReportingGroupShare,
    deleteCustomTemplateQuery,
    getQualifiedPipelineStageValue
}